import React, { PureComponent } from 'react';
import {
  PixelRatio,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import _ from 'lodash';

import Constants from '../utils/Constants';
import Utils from '../utils/Utils';

class OrderItem extends PureComponent {

  _handleClick = () => {
    const {data, onClick} = this.props;
    if (onClick) {
      onClick(data);
    }
  };

  render () {
    const {simple, data} = this.props;
    let {email, phone, status, commission, shippingCode, activateCode, paymentMethod} = data;
    email = _.isEmpty(email) ? 'N/A' : email;
    phone = _.isEmpty(phone) ? 'N/A' : phone;
    return (
      <TouchableOpacity
        activeOpacity={0.75}
        style={styles.item}
        onPress={this._handleClick}>
        <View
          style={[
            styles.column, {
              flex: 2,
            }]}>
          <Text
            style={styles.columnText}>
            {email}
          </Text>
        </View>

        <View
          style={styles.column}>
          <Text
            style={styles.columnText}>
            {phone}
          </Text>
        </View>

        <View
          style={styles.column}>
          <Text
            style={styles.columnText}>
            {!simple && Platform.OS === 'web' && paymentMethod !== null &&
            typeof paymentMethod !== 'undefined'
              ? '[' + paymentMethod.toUpperCase() + '] '
              : ''}{Constants.STATUS_LOOKUP.get(status)}
          </Text>
        </View>

        <View
          style={styles.column}>
          <Text
            style={styles.columnText}>
            {Utils.priceToString(commission)}
          </Text>
        </View>
        {!simple && Platform.OS === 'web' &&
        <View
          style={styles.column}>
          <Text
            style={styles.columnText}>
            {shippingCode}
          </Text>
        </View>
        }
        {!simple && Platform.OS === 'web' &&
        <View
          style={styles.column}>
          <Text
            style={styles.columnText}>
            {activateCode}
          </Text>
        </View>
        }
        <View
          style={styles.divider}/>
      </TouchableOpacity>
    );
  }
}

const styles = StyleSheet.create({
  item: {
    height: 48,
    flexDirection: 'row',
    backgroundColor: '#efefef',
  },
  column: {
    flex: 1,
    marginLeft: 8,
    flexDirection: 'row',
    alignItems: 'center',
  },
  columnText: {
    color: '#454c53',
    fontSize: 12,
    fontWeight: '100',
    backgroundColor: 'transparent',
  },
  divider: {
    position: 'absolute',
    left: 0, bottom: 0, right: 0,
    height: 1 / PixelRatio.get(),
    backgroundColor: '#6b7adc',
  },
});

export default OrderItem;



// WEBPACK FOOTER //
// ./src/item/OrderItem.js